import React from 'react'
import { FaXmark } from 'react-icons/fa6'

import { MessageActionsProps } from './'
import MenuItem from '~components/shared/menu/menu-item'
import { useUpdateMessageMutation } from '~graphql/generated/graphql'
import { useMessageProperties } from '../message-content/message-provider'

export default function RemoveAttachedPatient({
    message,
}: Pick<MessageActionsProps, 'message'>) {
    const { refetchMessages } = useMessageProperties()

    const [updateMessage] = useUpdateMessageMutation()

    const handleClearPatients = async () => {
        await updateMessage({
            variables: {
                chatId: message.chat.id,
                messageId: message.id,
                data: {
                    patientIds: [],
                },
            },
            onCompleted: () => {
                refetchMessages()
            },
        })
    }

    const count = message.patients?.length || (message.patient ? 1 : 0)

    if (count === 0) return null

    return (
        <MenuItem icon={FaXmark} onClick={handleClearPatients}>
            {count > 1 ? 'Clear all patients' : 'Remove patient'}
        </MenuItem>
    )
}
